import Konva from "konva";
import type Combatant from "@/encounter/model/Combatant.ts";
import type {MapTransform} from "@/encounter/model/ViewPort.ts";
import {CharacterSizes} from "@/characters/model/CharacterSizes.ts";
import {combatantsOnLevel} from "@/tabletop/tokens/CombatantLevel.ts";
import type {SelectionRectangle} from "./SelectionRectangleHooks.ts";

const MIN_SELECTION_SIZE_PIXELS = 30;

export function combatantsInSelectionRectangle(
    combatants: Combatant[],
    levelId: string | undefined,
    rectangle: SelectionRectangle,
    transform: MapTransform,
    baseIds: readonly string[],
): Combatant[] | undefined {
    const width = Math.abs(rectangle.x2 - rectangle.x1);
    const height = Math.abs(rectangle.y2 - rectangle.y1);
    if (width < MIN_SELECTION_SIZE_PIXELS || height < MIN_SELECTION_SIZE_PIXELS) return undefined;

    const selectionBox = {
        x: (Math.min(rectangle.x1, rectangle.x2) - transform.x) / transform.scale,
        y: (Math.min(rectangle.y1, rectangle.y2) - transform.y) / transform.scale,
        width: width / transform.scale,
        height: height / transform.scale,
    };
    const onLevel = combatantsOnLevel(combatants, levelId);
    const selectedIds = new Set(baseIds);
    onLevel.forEach(combatant => {
        const size = CharacterSizes.get(combatant.character.size) ?? 96;
        const token = {
            x: combatant.position.x - size / 2,
            y: combatant.position.y - size / 2,
            width: size,
            height: size,
        };
        if (Konva.Util.haveIntersection(selectionBox, token)) selectedIds.add(combatant.id);
    });
    return onLevel.filter(combatant => selectedIds.has(combatant.id));
}
